import React from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { subjectsData } from "./utils/subjects";

import "swiper/css";
import "swiper/css/pagination";
import classes from "./index.module.css";

const teamSlider = {
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  loop: true,
  spaceBetween: 20,
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
};

const Subjects = () => {
  const { t } = useTranslation();

  return (
    <div id="subjects">
      <h1 className={classes["header"]}>{t("Subjects")}</h1>

      <Swiper
        {...teamSlider}
        spaceBetween={30}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className={classes["swiper"]}
      >
        {subjectsData.map((value, index) => {
          return (
            <SwiperSlide className={classes["card"]}>
              <div className={classes["wrap"]}>
                <div className={classes["box"]}>
                  <Icon
                    className={classes["icons"]}
                    icon={value.icon_name}
                    width={"40"}
                  />
                </div>
                <div className={classes["number"]}>0{index + 1}</div>
              </div>
              <h1 className={classes["title"]}>{t(value.title)}</h1>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Subjects;
